import { Card } from '@avanta/shared/components/ui/Card';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import { useUserStore } from 'stores/user';
import { RatingsTable } from './RatingsTable';

export const PsychologistRatings = (): React.ReactElement | null => {
  const { t } = useTranslation(LOCIZE_NS.PROFILE);
  const isPsychologist = useUserStore(state => state.isPsychologist);
  const user = useUserStore(state => state.user);

  if (!isPsychologist) {
    return null;
  }

  return (
    <Card
      title={t('PsychologistRatings.heading', {
        averageRate: Number(user?.averageRate)?.toFixed(2),
      })}
    >
      <RatingsTable />
    </Card>
  );
};
